"use client";

import { DirectusImage } from "@/components/DirectusImage";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";
import RouterLink from "@/components/ui/router-link";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { useScopedI18n } from "@/messages/client";

export function getNewsHref(
  isExternal?: boolean,
  externalLink?: string,
  slug?: string,
) {
  if (isExternal) {
    return externalLink;
  }
  if (slug) {
    return `/news/${slug}`
  }
  return undefined;
}

export default function NewsCover(props: {
  data?: {
    slug?: string;
    title?: string;
    date?: number;
    cover?: string;
    isExternal?: boolean;
    externalLink?: string;
    coverRatio?: number;
  } & Record<string, any>;
}) {
  const t = useScopedI18n("新闻");
  return (
    <RouterLink
      className="group rounded-xl hover-outline-shadow"
      target="_blank"
      href={getNewsHref(
        props.data?.isExternal,
        props.data?.externalLink,
        props.data?.slug
      )}
    >
      {props.data?.cover && (
        <AspectRatio className="overflow-hidden rounded-t-xl" ratio={props.data?.coverRatio || 1.9}>
          <DirectusImage
            className="w-full object-cover"
            alt={props.data?.title || ""}
            id={props.data?.cover}
            fill
            zoomInGroup
          />
        </AspectRatio>
      )}
      <div className="px-3 py-2 rounded-b-xl bg-zinc-100 md:px-10 md:py-5">
        <p className="text-xs h-8 font-bold line-clamp-2 text-ellipsis md:text-base md:h-12">
          {props.data?.title}
        </p>
        <div className="flex items-center justify-between mt-1.5 md:mt-5">
          {props.data?.date && (
            <span className="flex items-center text-xs">
              <CalendarDays color="#515151" size={14} />
              <span className="ml-1 text-zinc-400">{format(new Date(props.data.date), "yyyy.M.d")}</span>
            </span>
          )}
          <span className="flex items-end text-xs leading-none text-gray max-md:hidden">
            {t("新闻详情")}
            <img className="ml-1 w-8" src="/icon/detail-arrow.svg" alt="Icon Arrow" />
          </span>
        </div>
      </div>
    </RouterLink>
  )
}
